<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        申し込み詳細
      </template>

      <template v-slot:content>
        <v-row>
          <v-col cols="12" class="pa-0 ml-9">
            <v-chip dark class="my-1 mx-2" :class="getApplyTypeClass(applyType)">{{applyType}}</v-chip>
          </v-col>
        </v-row>
        <v-row class="mx-6">
          <v-col cols="12">
            <v-text-field
              v-model="code"
              disabled
              label="お客様No."
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mx-6">
          <v-col cols="12">
            <v-textarea
              v-model="name"
              disabled
              label="塾名"
              hide-details
              rows="2"
              no-resize
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row class="mx-6" v-if="logoImage">
          <v-col cols="4">
            <p>ロゴ</p>
            <v-img contain :src="logoImage" max-height="110px" position="top"/>
          </v-col>
        </v-row>
        <v-row class="mx-6">
          <v-col cols="5">
            <v-text-field
              v-model="invoiceType"
              label="請求方法"
              disabled
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mx-6" v-if="isNew">
          <v-col cols="5">
            <v-text-field
              v-model="startTime"
              label="利用開始時期"
              disabled
              hide-details=""
            ></v-text-field>
          </v-col>
        </v-row>
        <fieldset>
          <legend>塾情報</legend>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="postCode"
                disabled
                label="郵便番号"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="address"
                disabled
                label="住所"
                hide-details
                :rows="textareaRows.address"
                no-resize
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="tel"
                label="代表電話番号"
                disabled
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="mail"
                label="メールアドレス"
                disabled
                :rows="textareaRows.email"
                no-resize
                hide-details
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="enChargePerson"
                label="EN担当者"
                disabled
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </fieldset>

        <template v-for="(branchRequest, index) in $store.state.apply.branchesRequests">
          <fieldset class="branch-fieldset" :key="'branch'+index">
            <legend>{{classroomLabel}}</legend>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="教室名"
                  :value="branchRequest.branch.name"
                  disabled
                  hide-details
                  rows="2"
                  no-resize
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="ログインID"
                  :value="branchRequest.branch.userLogin"
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="password"
                  label="パスワード"
                  disabled
                  hide-details
                  type="password"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="教室電話番号"
                  :value="branchRequest.branch.tel"
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="教室担当者名"
                  :value="branchRequest.branch.representative"
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="教室担当者メールアドレス"
                  :value="branchRequest.branch.email"
                  disabled
                  hide-details
                  :rows="textareaRows.email"
                  no-resize
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="isAdd">
              <v-col cols="12">
                <v-text-field
                  label="利用開始時期"
                  :value="branchRequest.startTimeI18n"
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </fieldset>
        </template>

        <fieldset class="branch-fieldset" v-if="isCancel">
          <legend>解約情報</legend>
          <p class="cancel__reason mb-0" style="display:inline-block">解約理由：</p>
          <div v-for="(reason, index) in cancellationReasons" :key="index">
            <p class="cancel__reason mb-0">・{{reason}}</p>
          </div>
          <p class="cancel__reason mt-2 mb-0" style="display:inline-block">解約申請者名：</p>
          <p class="cancel__name mb-0">{{cancellationApplicant}}</p>
          <v-btn class="mt-3 export__btn" small color="#4a81aa" dark @click.stop="download">エクセル出力</v-btn>
        </fieldset>

        <template v-if="!isNew">
          <v-row>
            <v-col class="pb-0 pl-0">
              <p class="mx-9 classroom-text">登録済教室一覧</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="classroom-table pr-9">
              <v-card class="ml-6">
                <v-data-table

                  :headers="headers"
                  :items="accounts"
                  disable-pagination
                  hide-default-footer
                  mobile-breakpoint=10
                >
                  <template #[`item.edit`]="{ }">
                    <v-btn icon @click.stop="$router.push('/admin/classroom_edit')">
                      <v-icon small dark>
                        mdi-cog-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <template #[`item.delete`]="{ item }">
                    <v-btn icon @click.stop="openDeleteConfirmDialog(item)">
                      <v-icon dark>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </template>

        <v-col>
          <v-btn class="mt-6 ml-3" color="secondary" dark @click.stop="openApprovedConfirmDialog()">承認する</v-btn>
          <router-link to="/admin/home">
            <v-btn class="mt-6 ml-6" color="gray">申込一覧に戻る</v-btn>
          </router-link>
        </v-col>
      </template>
    </v-base-card>


    <v-confirm-dialog
      ref="confirm"
      title="申し込み承認"
      :message="approvedMessage"
      buttonMessage="承認する"
      @confirm="confirmDeletion"
    />
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'
import { saveAs } from 'file-saver'

export default {
  components: {
    VBaseCard,
    VConfirmDialog,
  },
  data () {
    return {
      password: 'password',
      accounts: [],
      headers: [
        { text: 'ログインID', align: 'start', value: 'users[0].login' },
        { text: '教室名', align: 'center', value: 'name', sortable: false },
        { text: '利用状況', align: 'center', value: 'useStatus', sortable: false },
        { text: '期間', align: 'center', value: 'agreementEndOn', sortable: false },
      ],
      textareaRows: {
        address: 2,
        email: 1
      }
    }
  },

  async mounted() {
    window.addEventListener( 'resize', this.resize, false);
    this.resize()
    if (this.customerId) this.getAccounts()
  },

  beforeDestroy() {
    window.removeEventListener( 'resize', this.resize, false);
  },

  computed: {
    id() {
      return this.$store.state.apply.id
    },
    customerId() {
      return this.$store.state.apply.customer.id;
    },
    name() {
      return this.$store.state.apply.customer.name
    },
    code() {
      return this.$store.state.apply.customer.code
    },
    logoImage() {
      if (!this.$store.state.apply.customer.logoUrl) return ''
      return `${this.$axios.defaults.baseURL}` + this.$store.state.apply.customer.logoUrl
    },
    invoiceType() {
      return this.$store.state.apply.customer.billing=="yearly_billing" ? '年間' : '月々'
    },
    postCode() {
      return this.$store.state.apply.customer.postCode
    },
    address() {
      return this.$store.state.apply.customer.address
    },
    tel() {
      return this.$store.state.apply.customer.tel
    },
    mail() {
      return this.$store.state.apply.customer.email
    },
    enChargePerson() {
      return this.$store.state.apply.customer.representative
    },
    branches() {
      const branches = []
      this.$store.state.apply.branches.forEach(x => {
        branches.push({
          id:     x.id,
          name:   x.name,
          room:   x.useStatus,
          period: x.agreementEndOn,
        })
      })
      return branches
    },
    isNew() {
      return this.$store.state.apply.typeName === '新規'
    },
    isAdd() {
      return this.$store.state.apply.typeName === '教室追加'
    },
    isCancel() {
      return this.$store.state.apply.typeName === '解約'
    },
    classroomLabel() {
      const convert = {
        '新規': '',
        '教室追加': '追加',
        '解約': '解約'
      }
      return convert[this.$store.state.apply.typeName]+'教室情報'
    },
    applyType() {
      return this.$store.state.apply.typeName
    },
    startTime() {
      return this.$store.state.apply.startTimeI18n
    },
    cancellationApplicant() {
      return this.$store.state.apply.cancellationApplicant
    },
    cancellationReasons() {
      return this.$store.state.apply.cancellationReasons
    },
    approvedMessage() {
      return `申込ID:${this.$store.state.apply.id}の [${this.$store.state.apply.typeName}]申し込みを承認します。よろしいですか。`
    },
  },

  methods: {
    resize() {
      if (this.$app.$el.clientWidth < 1090) {
        this.textareaRows.address = 3
        this.textareaRows.email = 2
      } else {
        this.textareaRows.address = 2
        this.textareaRows.email = 1
      }
    },
    // 塾IDに紐付く教室一覧を取得
    async getAccounts() {
      const res = await this.$axios.get('/api/v1/admin/branches?customer_id=' + this.customerId)
      this.accounts = res.data
    },
    async confirmDeletion() {
      this.$app.$refs.loading.open({type: 'normal', message: '承認処理中です。少々お待ち下さい。'})
      const url = `api/v1/admin/requests/${this.$store.state.apply.id}/approve`
      await this.$axios.put(url)
        .then((res)=> {
          this.$app.$refs.loading.close()
          if (res.status === 'error') this.$toasted.global.error({ message: res.message })
          this.$toasted.global.success({ message: `申込ID:${this.$store.state.apply.id}を承認しました` })
          this.$router.push('/admin/home')
        })
    },
    openApprovedConfirmDialog() {
      this.$refs.confirm.open()
    },
    getApplyTypeClass(type) {
      let className = 'chip__type'
      if (type === '新規') return className + '-new'
      else if (type === '教室追加') return className + '-add-branch'
      else if (type === '解約') return className + '-delete'
    },
    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      return fileName
    },
    async download(){
      const res = await this.$axios.get(`/api/v1/admin/requests/${this.id}/download_cancellation.xlsx`, { responseType: 'blob', dataType: 'binary' })
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
    },
  }
}
</script>

<style lang="stylus" scoped>
fieldset
  margin 20px 23px
  width 96%
  padding 2px 15px 15px 15px
  border 1px solid #c6c6c6
  border-radius 5px

p
  margin-bottom 0px !important
  font-size 12px
  color #767676

label
  cursor pointer

.branch-fieldset
  margin-top 20px

.select
  font-size 11px !important

.approve
  display inline-block


.classroom
  &-text
    color #000000DE
    font-size 16px
  &-table
    padding-right 25px

.cancel__reason
  font-size 16px
  color black

.cancel__name
  display inline-block
  font-size 16px
  color black

.export__btn
  display block

.chip
  &__type
    &-new
      // background-color #3E90C6 !important
      width 85px
      height 21px !important
      text-align center
      font-size 12px !important
      font-weight bold
      // border-bottom 1px solid #c4c4c4
      display inline-block

      background-color: #ffffff !important;
      border: 1px solid #3e90c6;
      color: #3e90c6;

    &-add-branch
      // background-color #4caf50 !important
      width 85px
      height 21px !important
      text-align center
      font-size 12px !important
      font-weight bold
      // border-bottom 1px solid #337f36
      display inline-block

      background-color: #ffffff !important;
      border: 1px solid #4caf50;
      color: #4caf50;

    &-delete
      // background-color #cc564e !important
      width 85px
      height 21px !important
      text-align center
      font-size 12px !important
      font-weight bold
      // border-bottom 1px solid #993f39
      display inline-block

      background-color: #ffffff !important;
      border: 1px solid #cc564e;
      color: #cc564e;

</style>
